'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth0Js = require('auth0-js');

var _auth0Js2 = _interopRequireDefault(_auth0Js);

var _promisify = require('./promisify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// if promise hasn't been polyfilled polyfill it just for this file
var _Promise = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

_promisify.promisify.Promise = _Promise;

var UserMetadata =
// requires either an embeddedAuth(default or centralizedAuth)
function UserMetadata(auth) {
  var _this = this;

  _classCallCheck(this, UserMetadata);

  this.generateAuthManage = function () {
    if (!_this.auth.isLoggedIn()) {
      throw new Error('User must be logged in to perform management tasks');
    }

    var idToken = _this.auth.getToken();

    return new _auth0Js2.default.Management({
      domain: _this.auth.domain,
      token: idToken
    });
  };

  this.getUserMetadata = function (applicationKey) {
    var auth0Manage = _this.generateAuthManage();
    var key = applicationKey || _this.auth.clientID;
    var getUser = (0, _promisify.promisify)(auth0Manage.getUser.bind(auth0Manage));

    var profile = _this.auth.getProfile();

    return getUser(profile.sub).then(function (userData) {
      if (userData && userData.user_metadata && userData.user_metadata[key]) {
        return userData.user_metadata[key];
      }
      return {};
    });
  };

  this.patchUserMetadata = function (metadata, applicationKey) {
    var auth0Manage = _this.generateAuthManage();
    var key = applicationKey || _this.auth.clientID;
    var patchUser = (0, _promisify.promisify)(auth0Manage.patchUserMetadata.bind(auth0Manage));

    var profile = _this.auth.getProfile();
    var userMetadata = {};
    userMetadata[key] = metadata;

    return patchUser(profile.sub, userMetadata).then(function (userData) {
      return userData.user_metadata[key];
    });
  };

  this.auth = auth;
}

/// Default scoped to the clientID


/// Default scoped to the clientID
;

exports.default = UserMetadata;
//# sourceMappingURL=usermetadata.js.map
